import { destroyElementNode } from "@/helpers/utils";

export default {
  bind(el, binding, vNode) {
    const isAvailable = process.env[`VUE_APP_${binding.value}`];
    
    // comparing to string because value is from .env
    if (isAvailable === "false") {
      destroyElementNode(el, vNode);
    }
  },
}